import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import type { ReactElement, RefObject } from 'react';
import { IS_IE } from 'sdk';

import { useSDK } from '../../../../../app';
import { styled } from '../../../../../styled';
import { isMobile } from '../../../../../utils/isMobile';
import { MessageAttachmentIcon } from '../icons/messageAttachmentIcon';
import { MessageSendIcon } from '../icons/messageSendIcon';
import { BaseInterface, styles } from './common';
import { SmileIcon } from './smileIcon';

export interface ChatInterface extends BaseInterface {
	inRow: boolean;
	isInvolve?: boolean;
	children: ReactElement;
	onSendClick: VoidFunction;
	textareaRef?: RefObject<HTMLTextAreaElement>;
}

const Component = observer(
	({
		inRow,
		children,
		className,
		onSendClick,
		textareaRef,
		setShowEmoji,
		emojiPanelActive,
		isInvolve = false,
		onAttachmentClick,
		withAttachments = true,
	}: ChatInterface): ReactElement => {
		const { welcomeDataStore, attachmentsStore } = useSDK();

		const show1stGroup = welcomeDataStore.data?.showcase.useEmoji || welcomeDataStore.data?.showcase.useAttaches;
		const showEmoji = welcomeDataStore.data?.showcase.useEmoji && !isMobile && !IS_IE && setShowEmoji;
		const showAttachment = welcomeDataStore.data?.showcase.useAttaches && withAttachments;
		const disabledSendIcon = attachmentsStore.unsentAttachments.size
			? !attachmentsStore.unsentAttachments.size
			: !textareaRef?.current?.value;

		return (
			<div className={`${className} ${show1stGroup ? '' : ' jc-f-e'}`}>
				{inRow && show1stGroup && (
					<div className={`btn-group btn-group_${inRow ? 'row' : 'column'}`}>
						<div>
							{showAttachment && <MessageAttachmentIcon onClick={onAttachmentClick} />}
							{showEmoji && !inRow && (
								<SmileIcon
									className="ncc-emoji"
									active={!!emojiPanelActive}
									onClick={(): void => setShowEmoji(!emojiPanelActive)}
								/>
							)}
						</div>
					</div>
				)}
				{children}
				{inRow ? (
					<div className="btn-group btn-group_row">
						<div className="btn-wrapper">
							{showEmoji && (
								<SmileIcon
									className="ncc-emoji"
									active={!!emojiPanelActive}
									onClick={(): void => setShowEmoji(!emojiPanelActive)}
								/>
							)}
							<MessageSendIcon
								onClick={onSendClick}
								disabled={isInvolve ? !isInvolve : disabledSendIcon}
							/>
						</div>
					</div>
				) : (
					<div className="btn-group btn-group_column">
						{showAttachment && <MessageAttachmentIcon onClick={onAttachmentClick} />}
						{showEmoji && (
							<SmileIcon
								className="ncc-emoji"
								active={!!emojiPanelActive}
								onClick={(): void => setShowEmoji(!emojiPanelActive)}
							/>
						)}
						<MessageSendIcon onClick={onSendClick} disabled={isInvolve ? !isInvolve : disabledSendIcon} />
					</div>
				)}
			</div>
		);
	}
);

export const MessageFieldButtonsChat = styled(Component)(
	styles,
	css`
		height: auto;
		width: 100%;
	`
);
